import React from "react";
import "./App.scss"
import { BrowserRouter as Router, Route } from "react-router-dom";
import Terms from "./components/landing/Term/Terms";
import Contactus from "./components/landing/Contactus/Contactus";
import Privacypolicy from "./components/landing/Term/Privacypolicy";
import AccountDeletion from "./components/landing/Term/AccountDeletion";




function App() {
  return (
    <>

      <Router>
        <Route exact path="/" render={() => <Terms />} />
        <Route exact path="/terms-of-use" render={() => <Terms />} />
        <Route exact path="/privacy-policy" render={() => <Privacypolicy />} />
        <Route exact path="/account-deletion" render={() => <AccountDeletion />} />
        <Route exact path="/support" render={() => <Contactus />} />
      </Router>
    </>
  );
}

export default App;
